import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import DayJs from 'utils/Dayjs';
// import { secondsToParts } from 'utils/Helpers';
import { WEBINAR_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Progress from 'components/Misc/Progress';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button, Datepicker } from 'components/Misc/Form';

import { useAppStore } from 'store/useAppStore';

const Profile = () => {
	// Cache current object's id
	const { id } = useParams();

	// Use app's store
	const setTitle = useAppStore(state => state.setTitle);

	// Calulate how many seconds until start
	// const [left, setLeft] = useState({
	// 	days: 0,
	// 	hours: 0,
	// 	minutes: 0,
	// 	seconds: 0,
	// 	enabled: false,
	// 	visible: false
	// });

	// Seconds until end
	// const seconds = useRef(0);

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: '[subject, course]'
	}), []);

	// Store requested webinar
	const [[webinar, progress], collect] = useCollect(`webinars/${id}`, parameters);

	// Find type info
	const type = useMemo(() => WEBINAR_TYPES.find(type => type.value === webinar?.type), [webinar]);

	// Store if webinar is done
	const hasEnded = useMemo(() => DayJs(webinar?.eventAt).isBefore(DayJs().subtract(2, 'hour')), [webinar]);
	const hasStarted = useMemo(() => DayJs().add(15, 'minute').isAfter(DayJs(webinar?.eventAt)), [webinar]);

	// Set page's title
	useEffect(() => setTitle(webinar?.title), [webinar]);

	// Collect webinar on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Calculate seconds to start
	// useEffect(() => {
	// 	// Do not start calculations before date has been received
	// 	if (!webinar?.eventAt) return;

	// 	// Start instance
	// 	const start = DayJs(webinar?.eventAt);

	// 	// Calculate how many seconds until start
	// 	seconds.current = start.diff(DayJs(), 's');

	// 	// Do not initialize counter if difference is under 0
	// 	if (seconds.current <= 0) return setLeft(prev => ({
	// 		...prev,
	// 		enabled: true,
	// 		visible: false
	// 	}));

	// 	// Initialize with current seconds
	// 	setLeft(prev => ({
	// 		...prev,
	// 		...secondsToParts(seconds.current),
	// 		enabled: seconds.current <= 900,
	// 		visible: seconds.current <= 3600
	// 	}));

	// 	// Create 1 second interval
	// 	const interval = setInterval(() => {
	// 		// Do not decrement in negatives
	// 		if (seconds.current === 0) return;

	// 		// Decrement interval
	// 		seconds.current -= 1;
			
	// 		// Update timer
	// 		setLeft(prev => ({
	// 			...prev,
	// 			...secondsToParts(seconds.current),
	// 			enabled: seconds.current <= 900,
	// 			visible: seconds.current <= 3600
	// 		}));
	// 	}, 1000);

	// 	return () => clearInterval(interval);
	// }, [webinar]);

	return (
		<Container className="mx-auto max-w-screen-md p-4 space-y-4">
			{/* Show progress */}
			<Progress progress={progress} />

			{/* Show collected webinar */}
			<Show if={!progress && webinar?.id}>
				{/* Webinar's information */}
				<div className="flex flex-col space-y-2 md:flex-row md:items-center md:space-x-2 md:space-y-0">
					<Title
						title={webinar?.course?.title}
						subtitle={webinar?.subject?.title}
						className="flex-1 text-xl"
					/>

					<div className="flex space-x-2">
						<Pill
							name={type?.text}
							theme="informative"
						/>

						<Show if={webinar?.type === 'online'}>
							<Datepicker
								time
								readOnly
								value={webinar?.eventAt}
							/>
						</Show>
					</div>
				</div>

				{/* Show event date if webinar will be online */}
				<Show if={webinar?.type === 'online'}>
					{/* Countdown to webinar's beginning */}
					{/* <Show if={left.visible}>
						<div className="flex justify-center items-center text-4xl font-bold text-neutral-700 dark:text-white transition-colors">
							<div>{left.minutes}</div>
							<div className="mx-1 leading-none">:</div>
							<div>{left.seconds}</div>
						</div>
					</Show> */}

					{/* Information block after */}
					<Show if={hasEnded}>
						<div className="text-neutral-800 dark:text-white transition-colors">
							Vebinārs ir noslēdzies! Drīzumā tam būs pieejams ieraksts, kuru varēsi atrast dotā moduļa vebināru sarakstā!
						</div>
					</Show>

					{/* Information block before */}
					<Show if={!hasEnded && !hasStarted}>
						<div className="text-neutral-800 dark:text-white transition-colors">
							Vebināram varēs pieslēgties 15 minūtes pirms paredzētā laika! Ja ir tehniskas problēmas, zvaniet: 28604888
						</div>
					</Show>
				
					{/* Information block in last minutes */}
					<Show if={!hasEnded && hasStarted}>
						<div className="text-neutral-800 dark:text-white transition-colors">
							Spied uz pogas <b>&quot;Pieslēgties&quot;</b>, lai piedalītos <b>&quot;Zoom&quot;</b> vebinārā!
						</div>
					</Show>
						
					<div className="flex justify-end">
						<Button
							icon="link"
							theme="success"
							value="Pieslēgties"
							toOutside={(hasEnded || !hasStarted) ? '' : webinar?.url}
							disabled={hasEnded || !hasStarted}
						/>
					</div>
				</Show>

				{/* Show vod if webinar is recorded */}
				<Show if={webinar?.type === 'record' && webinar?.url}>
					<video controls className="w-full rounded-lg">
						<source src={webinar?.url} />
					</video>
				</Show>
			</Show>
		</Container>
	);
};

export default Profile;